// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1Ppby","error":"styles_error__1TA7d"};